import React from 'react';
import './CharacterCounter.css';

function CharacterCounter({ value, maxLength }) {
  const length = value ? value.length : 0;

  let status = '✅';
  let colorClass = 'valid';

  if (length > maxLength) {
    status = '❌';
    colorClass = 'invalid';
  }

  return (
    <div className={`character-counter ${colorClass}`}>
      <span className="counter-value">{value || ''}</span>
      <span className="counter-stats">
        ({length}/{maxLength}) {status}
      </span>
    </div>
  );
}

export default CharacterCounter;
